import React, { PropsWithChildren } from 'react';
import { Box, styled, SxProps, Theme } from '@mui/material';
import { Button, ButtonProps } from '@/components/Button';
import IconSVGArrowRight from 'ui-kit/lib/icons/24/Arrow/ChevronRight';
import { useTranslate } from '@/i18n/useTranslate';
import { INHERITED_DATA_TEST_ID } from '@/utils/testId.ts';

const PaginationLayout = styled('div')(() => ({
  display: 'inline-flex',
  gap: 10,
  margin: '0 -12px',
}));

const PgButton = styled(Button)(({ theme: t }) => ({
  fontWeight: 600,
  fontSize: '14px',
  lineHeight: '28px',
  padding: '0 14px',
  height: 30,
  '--icon-fill': t.palette.text.primary,
  minWidth: 'auto',
  '&:disabled': {
    pointerEvents: 'none',
    color: t.palette.grey[300],
    '--icon-fill': t.palette.grey[300],
  },
  '.MuiButton-startIcon': {
    marginRight: 6,
  },
  '.MuiButton-endIcon': {
    marginLeft: 6,
  },
}));
PgButton.defaultProps = {
  type: 'button',
  size: 'lg',
};

export const Prev = ({ children: __, ...restProps }: ButtonProps) => {
  const { t } = useTranslate('common');
  return (
    <PgButton
      data-test-id={INHERITED_DATA_TEST_ID}
      {...restProps}
      variant={'text'}
      color={'inherit'}
      startIcon={
        <Box
          component={IconSVGArrowRight}
          sx={{ transform: 'rotate(180deg)' }}
        />
      }
    >
      {t('PREV')}
    </PgButton>
  );
};

export const Next = ({
  children: __,
  ...restProps
}: Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'color'>) => {
  const { t } = useTranslate('common');
  return (
    <PgButton
      data-test-id={INHERITED_DATA_TEST_ID}
      {...restProps}
      variant={'text'}
      color={'inherit'}
      endIcon={<IconSVGArrowRight size={18} />}
    >
      {t('NEXT')}
    </PgButton>
  );
};

export const Pagination = ({
  className,
  children,
  show,
  sx,
}: PropsWithChildren<{
  className?: string;
  show: boolean;
  sx: SxProps<Theme>;
}>) => {
  if (!show) {
    return null;
  }
  return (
    <PaginationLayout sx={sx} className={className}>
      {children}
    </PaginationLayout>
  );
};
